import React from 'react';
import styled from 'styled-components';
import { Avatar } from '@prezi/avatar';
import { UserDisplayContainer, UserDisplayName, UserDisplayCaption, CloseIcon, IconButton } from '@prezi/common-components';
const Wrapper = styled.div.withConfig({
  displayName: "Collaborator__Wrapper",
  componentId: "sc-3cxydl-0"
})(["display:flex;align-items:center;margin:10px 0;"]);
const DetailsWrapper = styled.div.withConfig({
  displayName: "Collaborator__DetailsWrapper",
  componentId: "sc-3cxydl-1"
})(["display:flex;align-items:center;flex:1 1 auto;"]);
const Collaborator = ({
  name = '',
  email,
  isDeleteable,
  isUser,
  onRemove,
  confirmDeleteSelf
}) => {
  const [firstName, lastName] = name.split(' ');
  return React.createElement(Wrapper, null, React.createElement(DetailsWrapper, null, React.createElement(Avatar, {
    size: 34,
    firstName: firstName,
    lastName: lastName,
    email: email
  }), React.createElement(UserDisplayContainer, null, React.createElement(UserDisplayName, {
    size: 14
  }, name), React.createElement(UserDisplayCaption, {
    size: 12
  }, email))), isDeleteable && React.createElement(IconButton, {
    onClick: () => {
      if (isUser) {
        confirmDeleteSelf();
      } else {
        onRemove();
      }
    },
    shape: "circle",
    theme: "white",
    "data-lookup": "share-dialog-remove-collaborator-button"
  }, React.createElement(CloseIcon, null)));
};
export default Collaborator;